import React from 'react';
import { Link } from 'react-router-dom';

function VisaExtension() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .visa-ext-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Medical Visa Extension in Delhi NCR: A Private Healthcare Logistical Guide
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          When undergoing complex medical interventions abroad—such as intricate multi-stage oncology regimens, extensive orthopedic joint reconstructions, or cardiac recovery tracking—unplanned shifts in your healing timeline can occur. If your operating specialist recommends extending your post-operative recovery window, navigating the formal <strong>Medical Visa extension process</strong> becomes an essential logistical requirement.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          By tracking regulatory pathways on independent research indexes like <strong>Medical Trip World</strong>, international patient families can learn how to file prolongation requests through the digital <strong>Foreign Regional Registration Office (FRRO)</strong> framework safely, ensuring absolute compliance with sovereign stay guidelines without disrupting critical care.
        </p>
      </header>

      {/* CALL TO ACTION BUTTON */}
      <div style={{ marginBottom: '35px' }}>
        <Link to="/submit-query" style={{ 
          background: '#28a745', 
          color: '#fff', 
          padding: '14px 24px', 
          textDecoration: 'none', 
          borderRadius: '4px', 
          fontWeight: 'bold', 
          display: 'inline-block', 
          boxShadow: '0 2px 4px rgba(40,167,69,0.2)',
          fontSize: '0.95rem',
          textAlign: 'center',
          boxSizing: 'border-box',
          maxWidth: '100%'
        }}>
          Request Free Pre-Travel Stay Planning & Cost Guides →
        </Link>
      </div>

      {/* SECTION 1: THE FRRO EXTENSION PROCESS */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          How the Online FRRO Medical Stay Prolongation Works
        </h2>
        <p style={{ color: '#555', lineHeight: '1.7', marginBottom: '15px', fontSize: '0.95rem' }}>
          Sovereign immigration systems process all local stay modifications through an online portal managed by the Foreign Regional Registration Office (FRRO). International patients do not need to physically visit an immigration office; instead, applications are uploaded, reviewed, and issued digitally.
        </p>
        <p style={{ color: '#555', lineHeight: '1.7', margin: 0, fontSize: '0.95rem' }}>
          Unlike state-run public networks, premium private multi-specialty hospital groups in New Delhi, Gurgaon, and Noida manage dedicated international patient helpdesks. These internal teams coordinate closely with your primary operating consultants to draft the mandatory medical certificates, detailing why an extended recovery window (such as waiting for blood counts to stabilize after a bone marrow transplant or regaining mobility post-arthroplasty) is clinically necessary.
        </p>
      </section>

      {/* SECTION 2: DOCUMENTATION CHECKLIST MATRIX */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Mandatory Documentation for a Medical Stay Extension
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          To prevent administrative delays or sudden processing rejections, international travelers must ensure their private hospital's administrative desk compiles and uploads the following verified data segments:
        </p>

        <div style={{ background: '#f4f8fb', padding: 'clamp(15px, 4vw, 20px)', margin: '25px 0', borderRadius: '6px', borderLeft: '4px solid #005ba1', border: '1px solid #e2e8f0', borderLeftColor: '#005ba1', boxSizing: 'border-box' }}>
          <h3 style={{ marginTop: '0', color: '#005ba1', fontSize: '1.15rem', marginBottom: '12px' }}>📋 Required Stay Prolongation File Profiles:</h3>
          <ul style={{ marginTop: '10px', listStyleType: 'square', paddingLeft: '20px', lineHeight: '1.8', color: '#333', fontSize: '0.95rem' }}>
            <li style={{ marginBottom: '8px' }}><strong>Official Hospital Medical Certificate:</strong> A formal, signed document from the treating private institution specifying the patient's diagnostic status, current treatment phase, and the exact number of additional days or months required for safe recovery.</li>
            <li style={{ marginBottom: '8px' }}><strong>Comprehensive Indoor Case Sheets:</strong> Signed copies of private hospital laboratory panels, active pharmaceutical charts, or radiographical notes documenting ongoing clinical supervision.</li>
            <li style={{ marginBottom: '8px' }}><strong>Valid Passport & Visa Architecture:</strong> High-resolution digital scans of the primary patient’s passport, active entry stamp pages, and initial e-Medical Visa authorization forms.</li>
            <li style={{ marginBottom: '8px' }}><strong>Proof of Local Financial Solvency:</strong> Documented banking entries, international wire clearances, or private credit allocations demonstrating the family's capacity to cover extended inpatient or outpatient living expenses.</li>
            <li style={{ marginBottom: '0' }}><strong>Sovereign Lodging Registration (Form C):</strong> A mandatory residency tracking document generated directly by your specialized serviced apartment complex, recovery hotel, or private guest house.</li>
          </ul>
        </div>
      </section>

      {/* SECTION 3: ATTENDANT VISAS & IMMIGRATION SAFETY - RESPONSIVE MOBILE GRID */}
      <section style={{ marginBottom: '35px' }}>
        <h2 style={{ color: '#0b3c5d', borderBottom: '2px solid #e2e8f0', paddingBottom: '8px', fontSize: 'clamp(1.2rem, 5vw, 1.5rem)' }}>
          Managing Co-Dependent Visas and Compliance Baselines
        </h2>
        <p style={{ color: '#555', lineHeight: '1.6', fontSize: '0.95rem' }}>
          Because Medical Trip World functions exclusively as an open informational venue and independent directory index, we remind traveling families to proactively address these co-dependent stay factors:
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '20px', marginTop: '15px' }}>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Simultaneous Attendant Extensions</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              When filing for the primary patient’s stay modification, ensure that corresponding prolongation files are submitted for your registered companions holding e-Medical Attendant Visas to avoid accidental overstay penalties.
            </p>
          </div>
          <div style={{ padding: '20px', background: '#fafafa', borderRadius: '6px', border: '1px solid #e2e8f0', boxSizing: 'border-box' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem', fontWeight: '700' }}>Early Application Filing Windows</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.5' }}>
              Standard regulatory guidance dictates that extension paperwork be submitted through the digital FRRO portal at least 7 to 10 days before your initial visa validation window expires.
            </p>
          </div>
        </div>
      </section>

      {/* SECTION 4: IN-DEPTH FAQ */}
      <section style={{ marginBottom: '35px', background: '#fff', border: '1px solid #e2e8f0', padding: 'clamp(15px, 4vw, 25px)', borderRadius: '6px', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.25rem', fontWeight: '700' }}>
          Frequently Asked Questions (FAQs) – Visa Extensions & Stay Regulations
        </h3>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>What is the maximum duration allowed for a Medical Visa extension?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Depending on the exact medical condition and verified certificate entries provided by a licensed private multi-specialty institution, the FRRO can grant stay extensions in periodic blocks of 30 days up to an aggregate stay duration of one year.
          </p>
        </div>
        
        <div style={{ marginBottom: '20px' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Are there government fees associated with processing a visa extension?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            Yes, sovereign immigration processing fees vary based on the applicant's country of origin. These regulatory fees are settled directly through the secure online FRRO portal using international credit cards or authorized digital payment tracks.
          </p>
        </div>
        
        <div style={{ marginBottom: '0' }}>
          <p style={{ fontWeight: 'bold', color: '#333', margin: '0 0 6px 0', fontSize: '0.95rem' }}>Does Medical Trip World interface with immigration officers or file extension forms?</p>
          <p style={{ color: '#666', margin: '0', fontSize: '0.9rem', lineHeight: '1.6' }}>
            No. Medical Trip World operates strictly as an independent informational reference manual and open directory framework. We do not manage visa filings, communicate with sovereign immigration offices, or generate medical certificates. All administrative processing, financial cost mapping, and legal stay agreements exist directly and solely between the patient and their independently selected private medical provider.
          </p>
        </div>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center' }}>
        <p style={{ fontSize: '1.05rem', fontWeight: 'bold', color: '#333', margin: '0 0 15px 0' }}>Empower Your Global Healthcare Research Journey Safely</p>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/submit-query" className="visa-ext-footer-btn" style={{ background: '#28a745', color: '#fff', padding: '12px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block', boxShadow: '0 2px 4px rgba(40,167,69,0.15)' }}>
            Submit General Information Request
          </Link>
          <Link to="/compare-costs" className="visa-ext-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 20px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default VisaExtension;